import { Action } from '@ngrx/store';
import { Params } from '@angular/router';

import { ErrorResponse } from '~shared/models';
import { Filters, LocalFilters } from '../../models';

export enum LocalFiltersActionTypes {
  SAVE_LOCAL_FILTERS = '[Local filters] Local filters save',
  SAVE_LOCAL_FILTERS_SUCCESS = '[Local filters] Local filters save success',
  SAVE_LOCAL_FILTERS_FAILURE = '[Local filters] Local filters save failure',
  CLEAR_LOCAL_FILTERS = '[local filters] Local filters clear',
}

export class SaveLocalFilters implements Action {
  readonly type = LocalFiltersActionTypes.SAVE_LOCAL_FILTERS;

  constructor(public payload: { serverFilters: Filters, paramFilters: Params }) {
  }
}

export class SaveLocalFiltersSuccess implements Action {
  readonly type = LocalFiltersActionTypes.SAVE_LOCAL_FILTERS_SUCCESS;

  constructor(public payload: { filtersToSave: LocalFilters }) {
  }
}

export class SaveLocalFiltersFailure implements Action {
  readonly type = LocalFiltersActionTypes.SAVE_LOCAL_FILTERS_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {
  }
}

export class ClearLocalFilters implements Action {
  readonly type = LocalFiltersActionTypes.CLEAR_LOCAL_FILTERS;
}

export type LocalFiltersActionsUnion = SaveLocalFilters
  | SaveLocalFiltersSuccess
  | SaveLocalFiltersFailure
  | ClearLocalFilters;
